export const infoCircle = ['0 0 32 32',`
  <path d="M16 32c-8.788 0-15.974-7.186-15.974-16.026s7.186-15.974 15.974-15.974 15.974 7.186 15.974 15.974-7.134 16.026-15.974 16.026zM16 2.275c-7.548 0-13.7 6.152-13.7 13.7s6.152 13.7 13.7 13.7 13.7-6.152 13.7-13.7c0-7.548-6.152-13.7-13.7-13.7z"></path>
  <path d="M15.897 24.763c-0.62 0-1.137-0.517-1.137-1.137v-8.065c0-0.62 0.517-1.137 1.137-1.137s1.137 0.517 1.137 1.137v8.065c0.052 0.62-0.465 1.137-1.137 1.137z"></path>
  <path d="M17.861 10.029c0 1.085-0.88 1.964-1.964 1.964s-1.964-0.88-1.964-1.964c0-1.085 0.88-1.964 1.964-1.964s1.964 0.88 1.964 1.964z"></path>
`]

